// extracted by mini-css-extract-plugin
export var header = "_w9-1";
export var maskBottom = "_w9-6";
export var maskMiddle = "_w9-7";
export var maskTop = "_w9-5";
export var root = "_w9-0";
export var scrollDownButton = "_w9-3";
export var scrollDownButtonHidden = "_w9-4";
export var viewport = "_w9-2";